import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { GeneralCDMSService } from 'src/app/Services/Global/GeneralCDMS/general-cdms.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
  standalone: false,
})
export class ResetPasswordComponent implements OnInit {

  public newPassword: string = '';
  public confirmPassword: string = '';
  public resetError: string = '';
  public resetSuccess: boolean = false;
  public isLoading: boolean = false;
  public token: string = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private GeneralCDMS: GeneralCDMSService
  ) {}

  ngOnInit(): void {
    this.token = this.route.snapshot.queryParamMap.get('token') || '';
    if (!this.token) {
      this.resetError = 'Token inválido o expirado';
    }
  }

  async onSubmit(): Promise<void> {
    if (!this.newPassword.trim() || !this.confirmPassword.trim()) return;

    if (this.newPassword !== this.confirmPassword) {
      this.resetError = 'Las contraseñas no coinciden';
      return;
    }

    if (this.newPassword.length < 6) {
      this.resetError = 'La contraseña debe tener al menos 6 caracteres';
      return;
    }

    this.resetError = '';
    this.isLoading = true;

    try {
      const res = await firstValueFrom(
        this.GeneralCDMS.Reset_Password({ token: this.token, newPassword: this.newPassword })
      );

      if (res.success && res.operation.success) {
        this.resetSuccess = true;
        setTimeout(() => this.router.navigate(['/']), 3000);
      } else {
        this.resetError = res.message || 'No se pudo restablecer la contraseña';
      }

    } catch (e) {
      this.resetError = 'Error de conexión con el servidor';
    } finally {
      this.isLoading = false;
    }
  }

  goBack(): void {
    this.router.navigate(['/']);
  }
}